import {createAction} from '@reduxjs/toolkit'

export const populate = createAction('dataList/populate')
export const clear = createAction('dataList/clear')